window.addEventListener('load', () => {
    const dialogButtons = document.querySelectorAll("[data-dialog]");

    dialogButtons.forEach(button => {
        button.addEventListener('click', (e) => {
            const dialog = document.getElementById(e.target.dataset.dialog)
            if (dialog) {[
                dialog.showModal()
            ]}
        })
    })
})